<template>
  <base-container :isLoading="loading">
    <artisan-group style="height: 100%">
      <el-row slot="header" type="flex" align="middle">
        <span style="margin: 0 10px 0 0">日期范围:</span>
        <el-date-picker
          v-model="range"
          type="daterange"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :clearable="false"
          :picker-options="pickerOptions"
          size="mini"
          @change="loadSummaries"
        >
        </el-date-picker>
        <span style="margin: 0 10px 0 20px">院区:</span>
        <el-select v-model="hosId" size="mini" @change="wardId = ''">
          <el-option
            v-for="item in hosList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <span style="margin: 0 10px 0 20px">病区:</span>
        <el-select v-model="wardId" size="mini" placeholder="请选择">
          <el-option label="全部" value=""> </el-option>
          <el-option
            v-for="item in hosWards"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-button
          style="margin: 0 10px"
          type="primary"
          size="mini"
          icon="el-icon-search"
          @click="handleData"
        >
          查询
        </el-button>
      </el-row>

      <artisan-group title="住院预约占比">
        <div id="bedTotalChart" style="height: 300px"></div>
      </artisan-group>
    <artisan-group  tisan-group title="住院预约统计" style="margin: 5px">
        <div id="bedChart" style="height: 500px"></div>
      </artisan-group>
    </artisan-group>
  </base-container>
</template>
<script>
import { loadWardIdles } from "@/api/bed/idle";
import { all } from "@/api/basis/hos";
import { getWards } from "@/api/bed/ward";
import { summary } from "@/api/bed/record";
import moment from "moment";
import * as echarts from "echarts";
export default {
  data() {
    const start = new Date();
    start.setTime(start - 3600 * 1000 * 24 * 7);
    return {
      loading: false,
      range: [start, new Date()],
      hosId: "",
      wardId: "",
      date: "",
      type: "",
      hosList: [],
      wards: [],
      idles: [],
      summaries: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", [new Date(), new Date()]);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      totalMap: {
        inline: 0,
        audit: 0,
        yes: 0,
        no: 0,
        other: 0,
        idle: 0,
      },
      totalChart: "",
      totalOption: {
        tooltip: {
          trigger: "item",
          formatter: "{b} : <b>{c}</b> ({d}%)",
        },
        legend: {
          data: [
            "排队中",
            "已审核(通知数)",
            "确认入院",
            "无入院计划",
            "改期入院",
            "空床数",
          ],
        },
        color: ["#909399", "#409EFF", "#67C23A", "#F70303", "#E6A23C", "green"],
        series: [
          {
            type: "pie",
            radius: "55%",
            label: {
              formatter: "{b} : {c} ({d}%)",
            },
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
      myChart: "",
      option: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985",
            },
          },
        },
        toolbox: {
          show: true,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        legend: {
          data: [
            "排队中",
            "已审核(通知数)",
            "确认入院",
            "无入院计划",
            "改期入院",
            "空床数",
          ],
          left: "left",
        },
        color: ["#909399", "#409EFF", "#67C23A", "#F70303", "#E6A23C", "green"],
        grid: {
          left: "1%",
          right: "1%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            triggerEvent: true,
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [],
      },
    };
  },
  computed: {
    dates() {
      let arr = [];
      let start = moment(this.range[0]);
      let end = moment(this.range[1]).format("YYYY-MM-DD");
      do {
        arr.push(start.format("YYYY-MM-DD"));
        start = start.add(1, "days");
      } while (start.format("YYYY-MM-DD") <= end);
      return arr;
    },
    hosWards() {
      return this.wards.filter((c) => c.hosId == this.hosId);
    },
  },
  created() {
    all().then((res) => {
      this.hosList = res.data.data;
      if (this.hosList.length) {
        this.hosId = this.hosList[0].id;
      }
    });
    getWards().then((res) => {
      this.wards = res.data.data;
    });
  },
  mounted() {
    this.loadSummaries();
  },
  methods: {
    loadSummaries() {
      let start = moment(this.range[0]).format("YYYY-MM-DD");
      let end = moment(this.range[1]).format("YYYY-MM-DD");
      this.loading = true;
      summary(start, end)
        .then((res) => {
          this.summaries = res.data.data;
          return loadWardIdles("", start, end);
        })
        .then((res) => {
          this.loading = false;
          this.idles = res.data.data;
          this.handleData();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleData() {
      this.option.xAxis[0].data = this.dates;
      let optionMap = this.getOptionMap();
      this.totalMap.inline = 0;
      this.totalMap.audit = 0;
      this.totalMap.yes = 0;
      this.totalMap.no = 0;
      this.totalMap.other = 0;
      this.totalMap.idle = 0;
      let wardIds = this.hosWards.map((c) => c.id);
      this.summaries.forEach((c) => {
        let bl = false;
        if (this.wardId) {
          bl = c.wardId == this.wardId;
        } else {
          bl = wardIds.indexOf(c.wardId) >= 0;
        }
        if (bl) {
          const index = this.dates.indexOf(c.billDate);
          switch (c.status) {
            case "inline":
              optionMap.inline.data[index] += c.total;
              this.totalMap.inline += c.total;
              break;
            case "audit":
              optionMap.audit.data[index] += c.total;
              this.totalMap.audit += c.total;
              break;
            case "yes":
              optionMap.yes.data[index] += c.total;
              this.totalMap.yes += c.total;
              break;
            case "no":
              optionMap.no.data[index] += c.total;
              this.totalMap.no += c.total;
              break;
            case "other":
              optionMap.other.data[index] += c.total;
              this.totalMap.other += c.total;
              break;
          }
        }
      });
      this.idles.forEach((c) => {
        let bl = false;
        if (this.wardId) {
          bl = c.warId == this.wardId;
        } else {
          bl = wardIds.indexOf(c.warId) >= 0;
        }
        if (bl) {
          const index = this.dates.indexOf(c.idleDate);
          optionMap.idle.data[index] += c.idleCount;
          this.totalMap.idle += c.idleCount;
        }
      });
      this.option.series = [];
      for (const key in optionMap) {
        this.option.series.push(optionMap[key]);
      }
      this.totalOption.series[0].data = [];
      for (const key in this.totalMap) {
        this.totalOption.series[0].data.push({
          name: optionMap[key].name,
          value: this.totalMap[key],
        });
      }
      if (!this.totalChart) {
        this.totalChart = echarts.init(
          document.getElementById("bedTotalChart")
        );
      }
      this.totalChart.setOption(this.totalOption, true);
      if (!this.myChart) {
        this.myChart = echarts.init(document.getElementById("bedChart"));
        // this.myChart.on("click", (params) => {
        //   console.log(params);
        //   if (params.componentType == "xAxis") {
        //     alert("单击了" + params.value + "x轴标签");
        //   } else {
        //     alert("单击了" + params.name + "柱状图");
        //   }
        // });
      }
      this.myChart.setOption(this.option, true);
    },
    getOptionMap() {
      const labelOption = {
        show: true,
        position: "top",
        align: "center",
        formatter: "{c}",
        fontSize: 16,
        rich: {
          name: {
            textBorderColor: "#fff",
          },
        },
      };
      let map = {
        inline: {
          code: "inline",
          name: "排队中",
          type: "bar",
          label: labelOption,
          data: [],
        },
        audit: {
          code: "audit",
          name: "已审核(通知数)",
          type: "bar",
          label: labelOption,
          data: [],
        },
        yes: {
          code: "yes",
          name: "确认入院",
          type: "bar",
          label: labelOption,
          data: [],
        },
        no: {
          code: "no",
          name: "无入院计划",
          type: "bar",
          label: labelOption,
          data: [],
        },
        other: {
          code: "other",
          name: "改期入院",
          type: "bar",
          label: labelOption,
          data: [],
        },
        idle: {
          code: "idle",
          name: "空床数",
          type: "bar",
          label: labelOption,
          data: [],
        },
      };
      for (let index = 0; index < this.dates.length; index++) {
        map.inline.data.push(0);
        map.audit.data.push(0);
        map.yes.data.push(0);
        map.no.data.push(0);
        map.other.data.push(0);
        map.idle.data.push(0);
      }
      return map;
    },
  },
};
</script>
<style scoped>
.card-total {
  height: 50px;
  line-height: 50px;
  font-size: 27px;
  font-weight: bold;
  text-align: center;
}
</style>
